import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import Times from '@v2/context/Times/page';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsNCFileTimesProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const JobDetailsNCFileTimesComponent: FC<JobDetailsNCFileTimesProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
	ncFileData
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: true,
  });

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <Times
        withoutPaddingHorizontal
        ncFileId={ncFileData?.data?.ncFileId}
        style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
        horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
      />
    </JobContentWrapper>
  );
};

const JobDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileTimesComponent);

export { JobDetailsNCFileTimes };
